import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import axios from 'axios'
import { API_URL, SELF_URL } from '@/utils/constants'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const GridItem: FC<{
	tab?: string
	style: any
	numMap: any
	idMap: any
	myMap: any
	escrowMap: any
	setSelected: any
	selected: any
	index: any
	setSelectedEscrow: any
	selectedEscrowIndex: any
	isMouseDown: boolean
	slug: string
}> = (props): ReactElement => {
	const {
		style,
		numMap,
		idMap: _idMap,
		myMap,
		escrowMap,
		setSelected,
		selected,
		index,
		setSelectedEscrow,
		selectedEscrowIndex,
		isMouseDown,
		tab
	} = props

	const escrow_price = escrowMap[index]
	// useSatoshiPrice() kept for subscription side-effects; price unused here.
	useSatoshiPrice(escrow_price)
	const id = `grid-item-${index}`

	React.useEffect(() => {
		const square = document.getElementById(id)

		const handleMouseDown = (_e: any) => {
			if (escrow_price) {
				setSelectedEscrow(index)
				return
			}

			if (numMap[index]) {
				return
			}

			setSelected({ ...selected, [index]: !selected[index] })
		}

		const handleMouseEnter = (_e: any) => {
			if (!isMouseDown || escrow_price || numMap[index]) {
				return
			}

			setSelected({ ...selected, [index]: !selected[index] })
		}

		;(square as any)
			.addEventListener(
				'mouseenter',
				handleMouseEnter
			)(square as any)
			.addEventListener('mousedown', handleMouseDown)

		return () => {
			;(square as any)
				.removeEventListener(
					'mouseenter',
					handleMouseEnter
				)(square as any)
				.removeEventListener('mousedown', handleMouseDown)
		}
	}, [id, selected, setSelected, isMouseDown, escrow_price, numMap, index, setSelectedEscrow])

	const activeItem =
		tab === 'for-sale'
			? numMap[index] && escrow_price
			: tab === 'my-lands'
			? numMap[index] && myMap[index]
			: numMap[index]
	const myItem =
		tab === 'my-lands'
			? numMap[index] && myMap[index]
			: tab === 'for-sale'
			? numMap[index] && myMap[index] && escrow_price
			: myMap[index]
	const escrowItem = tab === 'my-lands' ? myMap[index] && escrow_price : escrow_price

	const handleClick = async () => {
		if (!escrowItem) {
			const url = `${API_URL}/${props.slug}/${index}`
			const { data } = await axios.get(url)
			window.open(`${SELF_URL}/inscription/${data?.id}`, '_blank')
		}
	}

	return (
		<div
			style={style}
			id={id}
			className={classNames(
				'border border-black flex items-center justify-center text-[5px] cursor-pointer flex-col select-none',
				{
					'bg-[#F7931A] opacity-20': !activeItem && !myItem && !escrowItem && numMap[index],
					'bg-[#F7931A]': activeItem,
					'bg-gradient-to-r from-purple-500 to-blue-500 opacity-100': selected[index],
					'bg-[#178EFE]': myItem,
					'bg-gradient-to-r from-yellow-500 to-orange-500': escrowItem,
					'border-[#178EFE]': selectedEscrowIndex === index
				},
				!activeItem && !myItem && !escrowItem && !numMap[index] && 'bg-gray-900'
			)}
			onClick={handleClick}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(handleClick)}
		>
			{index}
		</div>
	)
}

export default GridItem
